import { useState, useEffect } from "react";
import moment from "moment";

export const useCountdown = (end, format) => {
    const [seconds, setSeconds] = useState('-');
    const [minutes, setMinutes] = useState( '-');
    const [hours, setHours] = useState('-');
    const [days, setDays] = useState('-');
    const [endCountdown, setEndCountdown] = useState(end);

    useEffect(() => {
        let interval = null;
        const then = moment.utc(endCountdown, format);
        const countdown = moment.duration(then.diff(moment()));
        setEndCountdown(end);
        interval = setInterval(() => {
            setSeconds(countdown.isValid() ? countdown.get('seconds') : '-');
            setMinutes(countdown.isValid() ? countdown.get('minutes') : '-');
            setHours(countdown.isValid() ? countdown.get('hours') : '-');
            setDays(countdown.isValid() ? countdown.get('days') : '-');
        }, 1000);
        return () => clearInterval(interval);
    }, [end, endCountdown, seconds, minutes, hours, days]);

    return { seconds, minutes, hours, days };
}
